import sendBackToPCIcon from "@volumental/assets/icons/SendDataBackToPC.svg";
import { Container, Content, ErrorText, Text } from "@volumental/common";
import type { JSX } from "react";
import { useTranslation } from "react-i18next";
import { Header } from "../../../components/accessible-components";
import type { ScanResult, UserFlowType } from "../../../types/types";
import { QrCode } from "./qr-code";

interface QrCodeViewProps {
  onBack?: () => void;
  onClose: () => void;
  onScan: (scanResult: ScanResult) => void;
  flowType?: UserFlowType;
}
export function QrCodeView({ onBack, onClose, onScan, flowType }: QrCodeViewProps): JSX.Element {
  const { t } = useTranslation();
  return (
    <Container>
      <div className="bg-scanner-accent">
        <Header back={onBack} close={onClose} />
      </div>
      <Content disableGutters disableScrollbar>
        <div className="w-full text-center relative flex flex-col h-auto min-h-55 bg-scanner-accent gap-2">
          <div className="max-h-full rounded-2xl self-center mb-8 mt-2 flex flex-col items-center gap-6">
            <Text className="text-4xl">{t("scanQR")}</Text>
            {flowType ? (
              <QrCode onScan={onScan} flowType={flowType} />
            ) : (
              <ErrorText>{t("SomethingWentWrong")}</ErrorText>
            )}
          </div>
        </div>
        <div className="px-6 flex flex-col items-center text-center">
          <img
            src={sendBackToPCIcon}
            alt={t("imageAlt.qrWaiting")}
            className="aspect-square max-h-full object-contain rounded-2xl self-center max-w-40 pt-8"
          />
          <div className="text-center pt-4 pb-4">
            <Text>{t("scanResultsWillAppearHere")}</Text>
            <Text>{t("pleaseDoNotCloseScreen")}</Text>
          </div>
        </div>
      </Content>
    </Container>
  );
}
